import React from 'react';
import { Badge } from 'react-bootstrap';
import { isLiveDocument } from '../../Utils/billingoDocuments';

// Status → Bootstrap variant for a Billingo document. Shared across the
// per-order panel and the all-invoices list.
export const STATUS_VARIANT = {
  paid: 'success',
  partially_paid: 'warning',
  awaiting_payment: 'secondary',
  awaiting: 'secondary',
  issued: 'info',
  cancelled: 'danger',
  uploaded: 'light',
  not_sent: 'light',
};

// Status badge for a Billingo document.
export default function InvoiceStatusPill({ status }) {
  if (!status) return null;
  const variant = STATUS_VARIANT[status] || 'secondary';
  return (
    <Badge bg={variant} text={variant === 'light' ? 'dark' : undefined} className="fw-normal">
      {String(status).replace(/_/g, ' ')}
    </Badge>
  );
}

// A live Billingo document nobody has emailed yet. Issuing does not send it,
// so a document can sit unsent unnoticed — the lists say so beside its status.
export const isUnsent = (doc) => Boolean(doc?.billingo_document_id)
  && isLiveDocument(doc) && !doc.last_sent_at;

// A listed document's status, plus "not sent" when it applies.
export function DocumentStatus({ doc }) {
  return (
    <span className="d-inline-flex flex-wrap gap-1">
      <InvoiceStatusPill status={doc.status} />
      {isUnsent(doc) && <InvoiceStatusPill status="not_sent" />}
    </span>
  );
}
